import { useI18n } from '@/shared/i18n';
import { Sparkles } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

const LABELS: Record<string, string> = {
  mantenimiento: 'Mantenimiento',
  presupuesto: 'Presupuesto',
};

export function ComingSoon() {
  const [params] = useSearchParams();
  const { t } = useI18n();
  const key = params.get('key') ?? '';
  const label = LABELS[key] ?? key;

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4 text-center px-4">
      <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-violet-500 to-purple-600 flex items-center justify-center shadow-xl shadow-purple-500/30">
        <Sparkles size={28} className="text-white" />
      </div>
      {label && <h1 className="text-2xl font-bold text-theme">{label}</h1>}
      <p className="text-theme-secondary max-w-sm text-sm leading-relaxed">
        Esta sección estará disponible pronto. El equipo de Hommi está trabajando para traértela lo antes posible.
      </p>
      <span className="mt-2 inline-flex items-center gap-1.5 px-4 py-2 rounded-xl bg-primary-100 dark:bg-primary-900/40 text-primary-600 dark:text-primary-400 text-sm font-semibold">
        <Sparkles size={13} />
        {t('menu.v2.comingSoon')}
      </span>
    </div>
  );
}
